interface IProps {
  onClose: () => void;
}

const JoinGuideModal_2 = ({ onClose }: IProps): JSX.Element => {
  return (
    <>
      <div className="modal-overlay" id="termsPrivacyModal">
        <div className="modal-content modal-large">
          <button type="button" className="modal-close" id="termsPrivacyClose" onClick={onClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <h2 className="modal-title heading-4 font-bold">개인정보 보호 및 동의</h2>

            <div className="modal-scroll-content">
              <h3 className="modal-subtitle text-base font-bold">제1조 (개인정보의 수집 및 이용 목적)</h3>
              <p className="modal-text text-sm font-normal">
                1. 회사는 서비스 제공, 고객 지원, 법적 의무 준수, 마케팅 및 홍보를 목적으로 회원의 개인정보를
                수집·이용합니다.
                <br />
                2. 회사가 수집하는 개인정보는 다음과 같습니다:
                <br />
                - 필수정보: 이름, 연락처, 이메일, 지갑 주소, 본인 확인 정보
                <br />- 선택정보: 거래 내역, 위치정보 등
              </p>

              <h3 className="modal-subtitle text-base font-bold">제2조 (개인정보의 보유 및 이용기간)</h3>
              <p className="modal-text text-sm font-normal">
                1. 회사는 회원의 개인정보를 서비스 이용 기간 동안 보유하며, 이용 계약 종료 후에는 관련 법령에 따라 보유
                기간이 정해진 경우 이를 준수합니다.
                <br />
                2. 보유 기간이 종료된 개인정보는 즉시 파기합니다.
              </p>

              <h3 className="modal-subtitle text-base font-bold">제3조 (개인정보의 제3자 제공)</h3>
              <p className="modal-text text-sm font-normal">
                1. 회사는 회원의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다:
                <br />
                - 법령에 따라 요청이 있는 경우
                <br />- 회원이 사전에 동의한 경우
              </p>

              <h3 className="modal-subtitle text-base font-bold">제4조 (개인정보의 보호 및 관리)</h3>
              <p className="modal-text text-sm font-normal">
                1. 회사는 개인정보 보호법 및 관련 법령을 준수하며, 개인정보의 암호화, 접근 제한 등 안전한 관리에 필요한
                조치를 취합니다.
                <br />
                2. 회원은 개인정보 변경 사항을 즉시 회사에 통지해야 하며, 이를 이행하지 않아 발생한 문제에 대한 책임은
                회원에게 있습니다.
              </p>

              <h3 className="modal-subtitle text-base font-bold">부칙</h3>
              <p className="modal-text text-sm font-normal">본 약관은 2025년 11월 17일부터 적용됩니다.</p>
            </div>

            <button
              type="button"
              className="modal-button active text-lg font-semibold"
              id="termsPrivacyConfirm"
              onClick={onClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JoinGuideModal_2;
